import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "gatsby-plugin-wpgraphql-seo"
import PageContent from "../components/PageContent"

const PageTemplate = ({ data: { page }, location, pageContext }) => {
  const baseUrl = pageContext?.siteUrl
  const seoData = {
    ...page,
    seo: {
      ...page?.seo,
      opengraphImage: {
        ...page?.seo?.opengraphImage,
        sourceUrl: `${baseUrl}${page?.seo?.opengraphImage?.publicUrl}`,
      },
    },
  }
  return (
    <>
      <Layout location={location}>
        <Seo post={seoData} />
        <PageContent page={seoData} scrollReveal={false} />
      </Layout>
    </>
  )
}

export { Head } from "../components/Head"
export default PageTemplate

export const pageQuery = graphql`
  query PageById($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...PageFragment
    }
  }
`
